module.exports = __webpack_public_path__ + "static/rewards-card-lancer-marcus-98d1c5e77e9d34c7b1411f45402ef1cb.png";